import { useEffect, useRef } from "react";
import FileUpload from "../file-upload/file-upload";
import IconDelete from "../icons/icon-delete/icon-delete";
import IconImageRequest from "../icons/icon-image-request/icon-image-request";
import './media-upload.scss';
import { ICON_SIZE } from "../icons/icon-props-interface";
import MediaWithPlaceholder, { IMediaWithPlaceholderProps, MEDIA_VARIANTS } from "../media-with-placeholder/media-with-placeholder";

export interface IMediaUploadProps {
	uploadMedia: (fileData: File, fileContent: string | ArrayBuffer | null | undefined) => void,
	onDelete: (mediaFile: IUploadMediaFile) => void,
	isEditMode: boolean,
	buttonText?: string,
	maxFileSize?: number,
	multiple?: boolean,
	mediaFiles: IUploadMediaFile[],
	maximumNumberOfFiles?: number,
	fileTypes?: string[];
	acceptedFileFormats?: string;
}

export interface IUploadMediaFile extends Pick<IMediaWithPlaceholderProps, 'src' | 'alt' | 'mediaNotAvailable'> {
}

const MediaUpload: React.FC<IMediaUploadProps> = ({ uploadMedia, maxFileSize, multiple, mediaFiles, onDelete, isEditMode, buttonText = 'Upload Image', fileTypes = ["image/jpeg", "image/png", "image/gif"], acceptedFileFormats = ".jpg,.jpeg,.png,.gif" }) => {
	const ref = useRef<HTMLInputElement>(null);

	useEffect(() => {
		if (mediaFiles.length > 0 && ref.current) {
			ref.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
		}
	}, [mediaFiles.length]);
	return (
		<div className="media-upload" ref={ref}>
			{isEditMode &&
				<div className="media-upload-input">
					<div className={'media-icon-container'}>
						<IconImageRequest color="var(--color-semantic-3)" />
					</div>
					<FileUpload
						uploadFile={uploadMedia}
						buttonText={buttonText}
						readType="dataUrl"
						fileTypes={fileTypes}
						acceptedFileFormats={acceptedFileFormats}
						maxFileSize={maxFileSize}
						multiple={multiple}
					/>
				</div>
			}
			<div className={'uploaded-images'}>
				{mediaFiles.map((mediaFile: IUploadMediaFile, index: number) => {
					return (
						<div className="uploaded-image" key={index}>
							<MediaWithPlaceholder variant={MEDIA_VARIANTS.SMALL} src={mediaFile.src} enlargeSrc={mediaFile.src} mediaNotAvailable={mediaFile.mediaNotAvailable} />
							{isEditMode &&
								<div className="uploaded-image-delete" onClick={() => onDelete(mediaFile)}>
									<IconDelete size={ICON_SIZE.SMALL} color={'var(--color-accent-1)'} />
								</div>
							}
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default MediaUpload;